import React from "react";
import logo from "./logo.svg";
import "./App.css";
import img1 from "./images/image1.png";
import img2 from "./images/image2.png";
import img3 from "./images/image3.png";
import img4 from "./images/image4.png";
import img5 from "./images/image5.png";
import img6 from "./images/image6.png";
import img7 from "./images/image7.png";
import img8 from "./images/image8.png";
import img9 from "./images/image9.png";
import img10 from "./images/image10.png";
import img11 from "./images/image11.png";
import { Foo } from "./components/Foo";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <br />
      <br/>
      <Foo />
      <Footer/>
    </div>
  );
}

export default App;
